import Link from "next/link"
import { Button } from "@/components/ui/button"
import { ChevronRight, Sparkles } from "lucide-react"

export function ReadyToTry() {
  return (
    <section id="ready-to-try" className="relative py-24 md:py-32 bg-gradient-to-b from-gray-50 to-white dark:from-[#1E293B] dark:to-[#0F172A] overflow-hidden">

      
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Gradient orbs */}
        <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-primary/10 dark:bg-primary/20 rounded-full blur-3xl opacity-70"></div>
        <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-primary-light/10 dark:bg-primary-light/20 rounded-full blur-3xl opacity-70"></div>
        
        {/* Grid pattern */}
        <div className="absolute inset-0 bg-grid-gray-500/[0.03] dark:bg-grid-gray-400/[0.05] bg-[length:30px_30px]"></div>
      </div>

      <div className="container px-4 md:px-8 lg:px-12 mx-auto relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Card with gradient border */}
          <div className="relative">
            {/* Glowing border effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-primary/30 via-primary-light/30 to-primary/30 dark:from-primary/40 dark:via-primary-light/40 dark:to-primary/40 rounded-2xl blur-md opacity-70"></div>
            
            <div className="relative bg-white dark:bg-[#1E293B] rounded-2xl shadow-2xl border border-gray-200/50 dark:border-gray-800/50 p-12 md:p-16">
              {/* Floating sparkle decoration */}
              <div className="absolute -top-6 -right-6 bg-gradient-to-br from-primary to-primary-light text-white p-3 rounded-full shadow-lg">
                <Sparkles className="h-6 w-6" />
              </div>
              
              <div className="text-center mb-10">
                <div className="inline-flex items-center px-4 py-1 rounded-full text-sm font-medium bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary-light mb-4 backdrop-blur-sm">
                  READY TO TRY?
                </div>
                
                <h2 className="text-4xl md:text-5xl font-bold text-foreground dark:text-white mb-6 tracking-tight">
                  Start Simplifying <span className="text-primary dark:text-primary-light">Compliance</span>
                </h2>
                
                <p className="text-xl text-muted-foreground dark:text-gray-300 max-w-2xl mx-auto mb-10">
                  Join hundreds of care providers who are saving time and reducing stress with CareAdvisor&apos;s Minnesota-specific guidance.
                </p>
              </div>
              
              {/* Stats/benefits grid with hover effect */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                <div className="bg-gray-50 dark:bg-[#131E31] rounded-xl p-6 border border-gray-100 dark:border-gray-800/50 transition-all duration-300 hover:transform hover:-translate-y-1 hover:shadow-lg">
                  <div className="text-3xl font-bold text-primary dark:text-primary-light mb-2">10x</div>
                  <p className="text-muted-foreground dark:text-gray-400">Faster research</p>
                </div>
                <div className="bg-gray-50 dark:bg-[#131E31] rounded-xl p-6 border border-gray-100 dark:border-gray-800/50 transition-all duration-300 hover:transform hover:-translate-y-1 hover:shadow-lg">
                  <div className="text-3xl font-bold text-primary dark:text-primary-light mb-2">100%</div>
                  <p className="text-muted-foreground dark:text-gray-400">MN specific</p>
                </div>
                <div className="bg-gray-50 dark:bg-[#131E31] rounded-xl p-6 border border-gray-100 dark:border-gray-800/50 transition-all duration-300 hover:transform hover:-translate-y-1 hover:shadow-lg">
                  <div className="text-3xl font-bold text-primary dark:text-primary-light mb-2">24/7</div>
                  <p className="text-muted-foreground dark:text-gray-400">Access</p>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row justify-center gap-4 mt-10">
                <Button asChild size="lg" className="rounded-full relative overflow-hidden text-black bg-[#5BC0F8] hover:bg-[#4bb3ea] transition-all duration-300 shadow-md hover:shadow-xl">
                  <Link href="/chat">
                    <span className="relative z-10 font-medium px-2">Get Started Now</span>
                    <ChevronRight className="ml-1 h-5 w-5 relative z-10" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
          

        </div>
      </div>
      

    </section>
  )
}

